import React from "react"
import autobind from "class-autobind"
import { Paper } from "material-ui"
import strings from "../../localization/strings"
import { ELoggedInUserType } from "../../models"
import SettingsCard from "../../components/common/SettingsCard"
import * as permissionHelper from "../../helpers/permissionHelper"
import EmployeeNotificationSetting from "./EmployeeNotificationSetting"
import SupervisorNotificationSetting from "./SupervisorNotificationSetting"
import AccountStore from "../../stores/AccountStore"
interface IState {
	expanded: string
}

export default class NotificationSettings extends React.Component<any, IState> {
	constructor(props) {
		super(props)
		this.state = {
			expanded: "",
		}
		autobind(this)
	}

	componentDidMount(): void {
		document.title = `${strings.Notification_Settings} | ${strings.Findd_Grandd_Central}`
	}

	onExpandClick(type) {
		this.setState({ expanded: this.state.expanded === type ? "" : type })
	}

	render() {
		const loggedInUserType = permissionHelper.getLoggedInUserType()
		return (
			<div className="page-container Account">
				<div className="page-container-parent">
					<Paper
						zDepth={1}
						className="page-paper"
						style={{ padding: 20 }}
					>
						<div className="pageHeading" style={{ marginBottom: "20px" }}>
							{strings.Notification_Settings}
						</div>
						{[
							(loggedInUserType === ELoggedInUserType.Employee || loggedInUserType === ELoggedInUserType.EsAccUser) &&
							AccountStore.getScheduleEnabled() &&
							<SettingsCard
								key="EmployeeNotificationSetting"
								expanded={this.state.expanded === "EmployeeNotificationSetting"}
								cardLabel={strings.Personal_Notification_Preferences}
								handleExpandChange={() => this.onExpandClick("EmployeeNotificationSetting")}
							>
								<EmployeeNotificationSetting />
							</SettingsCard>,
							loggedInUserType !== ELoggedInUserType.Employee &&
							<SettingsCard
								key="SupervisorNotificationSetting"
								expanded={this.state.expanded === "SupervisorNotificationSetting"}
								cardLabel={strings.Subscription_Notifications}
								handleExpandChange={() => this.onExpandClick("SupervisorNotificationSetting")}
							>
								<SupervisorNotificationSetting />
							</SettingsCard>
						]}
					</Paper>
				</div>
			</div>

		)
	}
}